<script setup>
const props = defineProps(['id', 'label', 'options'])

const model = defineModel();
</script>

<template>
    <div class="field field--select option">
        <label v-html="label" :for="`attribute-${id}`"></label>
        
        <select :id="`attribute-${id}`" v-model="model" required>
            <option v-for="option in options" :value="option" v-html="option.label" :disabled="'' === option.id"></option>
        </select>
        
        <div class="image" v-if="model?.image">
            <p v-if="model.image.caption" v-html="model.image.caption"></p>
            <img :src="model.image.url" :width="model.image.width" :height="model.image.height" loading="lazy" :alt="model.image.alt">
        </div>
    </div>
</template>
